var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.steps, function(step, index) {
      return _c(
        "div",
        { key: index, staticClass: "step" },
        [
          step.name
            ? _c("div", { staticClass: "on" }, [
                _vm._v(_vm._s(_vm.$t("steps.on")) + ":  "),
                _c("b", [_vm._v(_vm._s(step.name) + " ")])
              ])
            : _vm._e(),
          _vm._v(" "),
          step.instruction
            ? [
                index !== _vm.steps.length - 1
                  ? _c(
                      "div",
                      { staticClass: "instruction" },
                      [
                        _c("b", {
                          staticStyle: { "font-size": "20px" },
                          domProps: {
                            innerHTML: _vm._s(_vm.instructionSymbol(step.type))
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(step.instruction) }
                        }),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticStyle: { height: "15px" },
                            attrs: {
                              "max-width": 30,
                              fab: "",
                              icon: "",
                              small: "",
                              title: _vm.$t("steps.gotoStep")
                            },
                            on: {
                              click: function($event) {
                                return _vm.stepClicked(step, index)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("remove_red_eye")])],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "arrived" },
                      [
                        _c("v-icon", { attrs: { color: "success" } }, [
                          _vm._v("place")
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(step.instruction) }
                        })
                      ],
                      1
                    )
              ]
            : _vm._e(),
          _vm._v(" "),
          step.distance
            ? _c("div", [
                _vm._v(_vm._s(_vm.$t("global.distance")) + ":  "),
                _c("b", [_vm._v(_vm._s(step.distance) + " ")])
              ])
            : _vm._e(),
          _vm._v(" "),
          step.duration
            ? _c(
                "div",
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v("access_time")
                  ]),
                  _vm._v(" "),
                  _c("b", [_vm._v(_vm._s(step.duration) + " ")])
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be252b16", { render: render, staticRenderFns: staticRenderFns })
  }
}